import { GrFormCheckmark } from "react-icons/gr"
import { isAdmin } from "../helpers/role"

import { TrackerState } from "../types/tracker"
import { Role } from "../types/user"

export const TRACKER_STATE_OPTIONS = [
  { label: "New", value: "new" },
  { label: "Provisioned", value: "provisioned" },
  { label: "Active", value: "active" },
  { label: "Decommissioned", value: "decommissioned" },
  { label: "In Maintenance", value: "in_maintenance" },
]

const provision = {
  label: "Provision",
  value: "provision",
  icon: GrFormCheckmark,
}
const activate = {
  label: "Activate",
  value: "activate",
  icon: GrFormCheckmark,
}
const maintenance = { value: "put_in_maintenance", icon: GrFormCheckmark, label: "Put in maintenance" }
const decommission = {
  label: "Decommission",
  icon: GrFormCheckmark,
  value: "decommission",
}
const restore = {
  label: "Restore",
  icon: GrFormCheckmark,
  value: "restore",
}

export const getTrackerStateOptions = (
  currentState: TrackerState,
  roles?: Role[],
  adminFeatures?: boolean,
) => {
  let options
  switch (currentState) {
    case "active":
      options = [maintenance, decommission]
      break
    case "in_maintenance":
      options = [activate, decommission]
      break
    case "new":
      options = isAdmin(roles) && adminFeatures ? [provision] : []
      break
    case "provisioned":
      options = [activate]
      break
    case "decommissioned":
      options = [activate]
      break
    default:
      options = [restore]
  }
  return options
}

export const TRACKER_MARKER_COLORS: { [key: string]: string } = {
  new: "blue",
  active: "blue",
  lost: "red",
  in_maintenance: "gray",
  provisioned: "gray",
  decommissioned: "gray",
  unknown: "gray",
}
